import { createContext, useState, useEffect } from 'react'

export const ProjectContext = createContext();

export const ProjectProvider = ({ children }) => {
  const [project, setProject] = useState(
    localStorage.getItem('project') ? JSON.parse(localStorage.getItem('project')) : []
  );
  const [projectType, setProjectType] = useState(project?.type);
  const [projectMaterials, setProjectMaterials] = useState(project?.materials);
  const [projectLaborBudget, setProjectLaborBudget] = useState(project?.laborBudget);
  const [projectTotalBudget, setProjectTotalBudget] = useState(project?.totalBudget);
  const [projectPostalCode, setProjectPostalCode] = useState(project?.postalCode);

  const setLocation = (location) => {
    updateProjectData('location', location);
  }

  const setPostalCode = (postalCode) => {
    updateProjectData('postalCode', postalCode);
    setProjectPostalCode(postalCode);
  }

  const setType = (type) => {
    updateProjectData('type', type);
    setProjectType(type);
  }

  const setArea = (area) => {
    updateProjectData('area', area);
  }

  const setLaborBudget = (laborBudget) => {
    updateProjectData('laborBudget', laborBudget);
    setProjectLaborBudget(laborBudget);
  }

  const setTotalBudget = (totalBudget) => {
    updateProjectData('totalBudget', totalBudget);
    setProjectTotalBudget(totalBudget);
  }

  const setDescription = (description) => {
    updateProjectData('description', description);
  }

  const setMaterials = (materials) => {
    updateProjectData('materials', materials);
    setProjectMaterials(materials);
  }

  const setSpacePhotos = (spacePhotos) => {
    updateProjectData('spacePhotos', spacePhotos);
  }

  const setContractorId = (contractorId) => {
    updateProjectData('contractorId', contractorId);
  }

  const setGeneratedAiData = (imageName, imageUrl, bom) => {
    let currentData = getGeneratedAiData() || {};

    const currentImageName = currentData.hasOwnProperty('imageName') ? currentData.imageName : null;
    const currentImageUrl = currentData.hasOwnProperty('imageUrl') ? currentData.imageUrl : null;
    const currentBom = currentData.hasOwnProperty('bom') ? currentData.bom : null;

    let newImageName = imageName ? imageName : currentImageName;
    let newImageUrl = imageUrl ? imageUrl : currentImageUrl;
    let newBom = bom ? bom : currentBom;

    updateProjectData('generatedAiData', { imageName: newImageName, imageUrl: newImageUrl, bom: newBom });
  }

  const getType = () => {
    return project?.type;
  }

  const getArea = () => {
    return project?.area;
  }

  const getPostalCode = () => {
    return project?.postalCode
  }

  const getMaterials = () => {
    return project?.materials;
  }

  const getSpacePhotos = () => {
    return project?.spacePhotos;
  }

  const getContractorId = () => {
    return project?.contractorId;
  }

  const getLaborBudget = () => {
    return project?.laborBudget;
  }

  const getTotalBudget = () => {
    return project?.totalBudget;
  }

  const getDescription = () => {
    return project?.description;
  }

  const getGeneratedAiData = () => {
    return project?.generatedAiData;
  }

  const updateProjectData = (key, data) => {
    setProject((prevProject) => {
      return {
        ...prevProject,
        [key]: data
      }
    });
  }

  const clearProjectContext = () => {
    setProject([]);
  }

  useEffect(() => {
    localStorage.setItem("project", JSON.stringify(project));
  }, [project]);

  useEffect(() => {
    const project = localStorage.getItem("project");
    if (project) {
      setProject(JSON.parse(project));
    }
  }, []);

  return (
    <ProjectContext.Provider
      value={{
        project,
        projectType,
        projectMaterials,
        projectLaborBudget,
        projectTotalBudget,
        projectPostalCode,
        setType,
        setArea,
        setLocation,
        setPostalCode,
        setLaborBudget,
        setTotalBudget,
        setDescription,
        setMaterials,
        setSpacePhotos,
        setContractorId,
        setGeneratedAiData,
        getType,
        getArea,
        getPostalCode,
        getLaborBudget,
        getTotalBudget,
        getDescription,
        getMaterials,
        getSpacePhotos,
        getContractorId,
        getGeneratedAiData,
        clearProjectContext
      }}
    >
      {children}
    </ProjectContext.Provider>
  );
};
